const Maintenance = (props) => {
  return (
    <div className="error-fallback">
      <div className="msg">LEAD 4D is currently down for maintenance, please try after some time. Thanks for your patience.</div>
    </div>
  );
};

export default Maintenance;
